import React from "react";

/**
 * A download link for one of an application's uploaded documents, or a dash
 * when the applicant did not attach it. Only the cover letter is mandatory on
 * the public form, so a missing resume is normal and a link to nothing is
 * worse than saying so.
 *
 * The stored file name becomes the tooltip and the download name, so a blob
 * URL full of timestamps still saves under something readable.
 */
const FileLink = ({ url, label, fileName }) => {
  if (!url) return <span style={{ color: "rgba(0, 0, 0, 0.35)" }}>N/A</span>;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={fileName || undefined}
      download={fileName || undefined}
    >
      {label}
    </a>
  );
};

export default FileLink;
